import { render, staticRenderFns } from "./yRadios.vue?vue&type=template&id=6b0d8104"
import script from "./yRadios.vue?vue&type=script&lang=js"
export * from "./yRadios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports